import type { ApolloClient } from '@apollo/client';

export function evictCacheData({
  apolloClient,
  cropIds = [],
  cropStepIds = [],
  blendIds = [],
  cropForBlendIds = [],
  taskIds = [],
  plantingIds = [],
  orderIds = [],
  orderInputIds = [],
  recurringOrderIds = [],
  recurringTaskIds = [],
  recurringPlantingIds = [],
}: {
  readonly apolloClient: ApolloClient<object>;
  readonly cropIds?: readonly string[];
  readonly cropStepIds?: readonly string[];
  readonly blendIds?: readonly string[];
  readonly cropForBlendIds?: readonly string[];
  readonly taskIds?: readonly string[];
  readonly plantingIds?: readonly string[];
  readonly orderIds?: readonly string[];
  readonly orderInputIds?: readonly string[];
  readonly recurringOrderIds?: readonly string[];
  readonly recurringTaskIds?: readonly string[];
  readonly recurringPlantingIds?: readonly string[];
}): void {
  for (const cropId of cropIds) {
    apolloClient.cache.evict({ id: `Crop:${cropId}` });
  }
  for (const cropStepId of cropStepIds) {
    apolloClient.cache.evict({ id: `CropStep:${cropStepId}` });
  }
  for (const recurringOrderId of recurringOrderIds) {
    apolloClient.cache.evict({ id: `RecurringOrder:${recurringOrderId}` });
  }
  for (const orderId of orderIds) {
    apolloClient.cache.evict({ id: `Order:${orderId}` });
  }
  for (const orderInputId of orderInputIds) {
    apolloClient.cache.evict({ id: `OrderInput:${orderInputId}` });
  }
  for (const recurringTaskId of recurringTaskIds) {
    apolloClient.cache.evict({ id: `RecurringTask:${recurringTaskId}` });
  }
  for (const taskId of taskIds) {
    apolloClient.cache.evict({ id: `Task:${taskId}` });
  }
  for (const plantingId of plantingIds) {
    apolloClient.cache.evict({ id: `Planting:${plantingId}` });
  }
  for (const cropForBlendId of cropForBlendIds) {
    apolloClient.cache.evict({ id: `CropForBlend:${cropForBlendId}` });
  }
  for (const blendId of blendIds) {
    apolloClient.cache.evict({ id: `Blend:${blendId}` });
  }
  for (const recurringPlantingId of recurringPlantingIds) {
    apolloClient.cache.evict({ id: `RecurringPlanting:${recurringPlantingId}` });
  }

  apolloClient.cache.gc();
}
